<div class="preview-container">
  <div class="controls" *ngIf="accounts.length">
    <p-dropdown
      [options]="accounts"
      optionLabel="name"
      optionValue="id"
      [(ngModel)]="selectedAccountId"
      [filter]="true"
      [filterBy]="'name'"
      filterPlaceholder="Search accounts"
      [showClear]="true"
      placeholder="Select an account"
      styleClass="wide-account-dropdown">
    </p-dropdown>
    <button pButton type="button" label="Load Preview" icon="pi pi-search" class="p-button-secondary" (click)="loadPreview()" [disabled]="!selectedAccountId || loading"></button>
  </div>

  <p-progressSpinner *ngIf="loading"></p-progressSpinner>

  <div *ngIf="!loading" class="preview-content">
    <div *ngIf="previewData" class="results">
      <ng-container *ngIf="previewData?.campaigns.length; else noCampaigns">
        <p> {{previewData?.campaigns.length}} campaign(s) found.</p>
        <ul>
          <li *ngFor="let campaign of previewData.campaigns">
            <i class="pi pi-bullseye icon-bullet"></i>
            {{ campaign }}
          </li>
        </ul>
      </ng-container>
      <ng-template #noCampaigns>
        <p>No campaigns matched the provided selection.</p>
      </ng-template>
    </div>
  </div>

  <div class="footer">
    <button pButton type="button" label="Close" icon="pi pi-times" class="p-button-text" (click)="close()"></button>
  </div>
</div>
